export default {"src":"/_next/static/media/tafeltennis.9646ccb1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};